import { render, staticRenderFns } from "./wuliao.vue?vue&type=template&id=7086bf86&scoped=true&"
import script from "./wuliao.vue?vue&type=script&lang=js&"
export * from "./wuliao.vue?vue&type=script&lang=js&"
import style0 from "./wuliao.vue?vue&type=style&index=0&id=7086bf86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086bf86",
  null
  
)

export default component.exports